import {IBaseLookup} from "./Ibase.lookup";

export namespace Laterality {

    export const lookupName: string = "Laterality";

    export interface Laterality {
        lateralityKey: number;
        code: string;
        description: string;
        active: string;
        lastUpdated: Date;
        reportText: string;
    }

    export interface LateralityDS extends IBaseLookup {
        laterality: Laterality[];
    }
}
